import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import PlusFeatureUpsellModal from '@alltrails/upsell/components/UpsellSystem/FeatureUpsell/PlusFeatureUpsellModal';
import headerImageSrc from './upsell.avif';

type Props = {
  isOpen: ComponentProps<typeof PlusFeatureUpsellModal>['isOpen'];
  onCloseRequest: ComponentProps<typeof PlusFeatureUpsellModal>['onCloseRequest'];
};

export default function DistanceAwayUpsellModal({ isOpen, onCloseRequest }: Props) {
  return (
    <PlusFeatureUpsellModal
      headerImageSrc={headerImageSrc}
      heading={<FormattedMessage defaultMessage="Filter trails by distance from any location" />}
      promoEligibleHeading={<FormattedMessage defaultMessage="Try Distance Away and more for free" />}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      upsellTrigger="Distance Away"
    />
  );
}
